export type LoaderProps = {
  size?: "small" | "medium" | "large";
  variant?: "primary" | "secondary" | "brand";
  class?: string;
};

const getSizeClasses = (size: string) => {
  const sizeMap = {
    small: {
      container: "gap-1",
      dot: "w-2 h-2"
    },
    medium: {
      container: "gap-1.5",
      dot: "w-3 h-3"
    },
    large: {
      container: "gap-2",
      dot: "w-4 h-4"
    }
  };
  return sizeMap[size as keyof typeof sizeMap];
};

const getVariantClasses = (variant: string) => {
  const variantMap = {
    primary: "bg-text-normal-primary",
    secondary: "bg-text-normal-secondary",
    brand: "bg-feature-base"
  };
  return variantMap[variant as keyof typeof variantMap];
};

export default function Loader(props: LoaderProps) {
  const size = props.size || "medium";
  const variant = props.variant || "primary";

  const sizeClasses = getSizeClasses(size);
  const variantClass = getVariantClasses(variant);

  return (
    <>
      <style>
        {`
          @keyframes telescope-loader-pulse {
            0%, 60%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            30% {
              opacity: 1;
              transform: scale(1.2);
            }
          }

          .telescope-loader-dot {
            animation: telescope-loader-pulse 1400ms ease-in-out infinite;
          }

          .telescope-loader-dot:nth-child(1) {
            animation-delay: 0ms;
          }

          .telescope-loader-dot:nth-child(2) {
            animation-delay: 200ms;
          }

          .telescope-loader-dot:nth-child(3) {
            animation-delay: 400ms;
          }
        `}
      </style>
      <div
        class={`flex items-center justify-center ${sizeClasses.container} ${props.class || ""}`}
        role="status"
        aria-label="Loading"
      >
        <div class={`${sizeClasses.dot} ${variantClass} rounded-full telescope-loader-dot`} />
        <div class={`${sizeClasses.dot} ${variantClass} rounded-full telescope-loader-dot`} />
        <div class={`${sizeClasses.dot} ${variantClass} rounded-full telescope-loader-dot`} />
      </div>
    </>
  );
}